import http, { httpWhatsapp } from '../../services/http';
import { WhatsAppActionTypes } from './whatsapp.types';
import { setLoading, setNotLoading } from '../loading/loading.actions';

export const selectInstanceWhatsapp = (state) => state.whatsapp.instanceWhatsapp;
export const selectQRCode = (state) => state.whatsapp.qrCode;
export const selectQRCodeBase64 = (state) => state.whatsapp.qrCodeBase64;
export const selectChats = (state) => state.whatsapp.chats;
export const selectCurrentMessages = (state) => state.whatsapp.currentMessages;
export const selectPageInfo = (state) => state.whatsapp.pageInfo;

export const setQRCodeBase64 = (qrCodeBase64) => ({
  type: WhatsAppActionTypes.GET_QR_BASE64_SUCCESS,
  payload: qrCodeBase64,
  timestamp: new Date().getTime()
});

export const setLoadingScreen = (percent, message, key) => ({
  type: WhatsAppActionTypes.SET_LOADING_SCREEN,
  payload: { percent, message, key }
});

export const setWhatsAppChats = (chats) => ({
  type: WhatsAppActionTypes.GET_WHATSAPP_CHATS_SUCCESS,
  payload: chats
});

export const setCurrentChatMessages = (messages) => ({
  type: WhatsAppActionTypes.GET_WHATSAPP_CHAT_MESSAGES_SUCCESS,
  payload: messages
});

export const appendMessages = (messages) => ({
  type: WhatsAppActionTypes.APPEND_WHATSAPP_CHAT_MESSAGES,
  payload: messages
});

export const setPageInfo = (pageInfo) => ({
  type: WhatsAppActionTypes.SET_WHATSAPP_PAGE_INFO,
  payload: pageInfo
});

export const loadMoreMessages = (roomId, page = 1) => async (dispatch, getState) => {
  try {
    const { pageInfo } = getState().whatsapp;

    const response = await http.get(`/messages/${roomId}`, {
      params: { page, limit: 30 }
    });

    const data = response.data;

    dispatch(appendMessages(data.data));
    dispatch(setPageInfo({ currentPage: page }));

    if (data.data.length < 30) {
      dispatch(setPageInfo({ currentPage: page, hasMore: false }));
    }

  } catch (error) {
    console.error('Erro ao carregar mais mensagens:', error);
  }
};

export const updateWhatsAppRoom = (room) => async (dispatch) => {
  try {
    await http.post('/whatsapp/update-room', room);
  } catch (error) {
    console.error("Erro ao atualizar sala:", error);
  }
}

export const editInstance = (instance) => async (dispatch, getState) => {
  dispatch({ type: WhatsAppActionTypes.EDIT_INSTANCE_REQUEST });
  let cleaned = instance.key.replace(/\D/g, "");
  // if (cleaned.startsWith("55")) {
  //   cleaned = cleaned.slice(2);
  // } else {
  //   cleaned = '55' + cleaned;
  // }

  try {
    await http.put(`/whatsapp/${cleaned}`, instance);
    dispatch({
      type: WhatsAppActionTypes.EDIT_INSTANCE_SUCCESS
    });
  } catch (error) {
    dispatch({
      type: WhatsAppActionTypes.EDIT_INSTANCE_FAILURE,
      payload: error.response ? error.response.data : error.message
    });
  } finally {
  }
}